import VipServiceSelect from './components/VipServiceSelect.css';
import Segment from './components/Segment/Segment.css';
export default {
    VipServiceSelect,
    Segment
};
